import { ReactNode } from "react";
import Box from "@mui/material/Box";

export default function CoreStrongText({ color, children }: { color?: "dark" | string; children?: ReactNode }) {
	return (
		<Box component="strong" color={color === "dark" ? "#141414" : color}>
			{children}
		</Box>
	);
}
